import React from 'react'

import PurchaseOrPrintButton from '../../purchase-print/PurchaseOrPrintButton'
import AddToButton from '../AddToButton'
import SoundCheckButton from '../SoundCheckButton'
import EditableCopyButton from './EditableCopyButton'

const OwnerControls: React.FC = () => {
  return (
    <div className="flex flex-col gap-2">
      <AddToButton />
      <EditableCopyButton />
      <SoundCheckButton />
      <PurchaseOrPrintButton />
    </div>
  )
}

export default OwnerControls
